import layout from '@views/layout/index.vue';

const walkthroughRoutes = [
  {
    path: '/gp',
    name: 'nav',
    component: layout,
    children: [
      // 新加我
      {
        path: 'mine',
        name: 'mine',
        component: () => import('@views/mine/index.vue'),
        redirect: 'mine/mineindex',
        children: [
          {
            path: 'datainterest',
            name: 'datainterest',
            meta: {
              pageType: 'datainterest',
              pageName: '趣味数据',
              keepAlive: true,
            },
            component: () => import(/* webpackChunkName: "datainterest" */'@views/mine/datainterest/index.vue'),
          },
          {
            path: 'datagrenade',
            name: 'datagrenade',
            meta: {
              pageType: 'datagrenade',
              pageName: '道具数据',
              keepAlive: true,
            },
            component: () => import(/* webpackChunkName: "datagrenade" */'@views/mine/datagrenade/index.vue'),
          },
          {
            path: 'datafriend',
            name: 'datafriend',
            meta: {
              pageType: 'datafriend',
              pageName: '好友排行',
              keepAlive: true,
            },
            component: () => import(/* webpackChunkName: "datafriend" */'@views/mine/datafriend/index.vue'),
          },
          {
            path: 'messageindex',
            name: 'messageindex',
            meta: {
              pageType: 'messageindex',
              pageName: '我的信息',
              keepAlive: true,
            },
            component: () => import('@views/mine/messageindex/index.vue'),
            redirect: 'messageindex/myrelease',
            children: [
              {
                path: 'myrelease',
                name: 'myrelease',
                meta: {
                  pageType: 'myrelease',
                  pageName: '系统消息',
                  keepAlive: true,
                },
                component: () => import(/* webpackChunkName: "myrelease" */'@views/mine/messageindex/myrelease/index.vue'),
              },
              {
                path: 'mymsg',
                name: 'mymsg',
                meta: {
                  pageType: 'mymsg',
                  pageName: '消息中心',
                  keepAlive: true,
                },
                component: () => import(/* webpackChunkName: "mymsg" */'@views/mine/messageindex/mymsg/index.vue'),
              },
              {
                path: 'mythumbup',
                name: 'mythumbup',
                meta: {
                  pageType: 'mythumbup',
                  pageName: '我的点赞',
                  keepAlive: true,
                },
                component: () => import(/* webpackChunkName: "mythumbup" */'@views/mine/messageindex/mythumbup/index.vue'),
              },
              // {
              //   path: 'mythumbup2',
              //   name: 'mythumbup2',
              //   meta: {
              //     pageType: 'mythumbup2',
              //     pageName: '我的点踩',
              //     keepAlive: true,
              //   },
              //   component: () => import('@views/mine/messageindex/mythumbup2/index.vue'),
              // },
            ],
          },
          {
            path: 'mineindex',
            name: 'mineindex',
            meta: {
              pageType: 'mypage',
              pageName: '个人主页',
            },
            component: () => import(/* webpackChunkName: "mineindex" */'@views/mine/mainpage/mineindex/index.vue'),
          },
          // 我的粉丝
          {
            path: 'minefan',
            name: 'minefan',
            meta: {
              pageType: 'mypage-fans',
              pageName: '个人粉丝页面',
              staticPageTitle: '我的粉丝',
              keepAlive: false,
            },
            component: () => import(/* webpackChunkName: "minefan" */'@views/mine/mainpage/minefan/index.vue'),
          },
          // 我的关注
          {
            path: 'mineattention',
            name: 'mineattention',
            meta: {
              pageType: 'mypage-attention',
              pageName: '个人关注页面',
              staticPageTitle: '我的关注',
              keepAlive: false,
            },
            component: () => import(/* webpackChunkName: "mineattention" */'@views/mine/mainpage/mineattention/index.vue'),
          },
        ],
      },
      // 发布
      {
        path: '/gp/publish',
        name: 'publish',
        meta: {
          pageType: 'releasepage',
          pageName: '发布界面',
          keepAlive: false,
          hideTopNav: true,
          hideRightNav: true,
        },
        component: () => import(/* webpackChunkName: "publish" */'@views/mine/publish/index.vue'),
      },
    ],
  },
  // 对比
  {
    path: '/gp/delight/:type',
    name: 'delight',
    meta: {
      pageType: 'delight',
      pageName: '对比',
    },
    component: () => import(/* webpackChunkName: "delight" */'@views/mine/delight/index.vue'),
  },
];

function addMeta(walkthroughRoute) {
  walkthroughRoute.children.forEach((route) => {
    if (route.children) {
      addMeta(route);
      return;
    }
    route.meta.sideBar = 'mine';
  });
}
addMeta(walkthroughRoutes[0]);

export default walkthroughRoutes;
